import React, {Fragment} from 'react';
import {Grid} from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import {
  ChildSectionTitle,
  SideLabelAutoCompleteWithRefInput,
  SecuritizedInput
 } from '../FormSectionComponents';  
import {
  PrepaymentTermsMakeWhole,
  PrepaymentTermsDefeasance,
  PrepaymentTermsSpreadMaintenance,
  PrepaymentTermsNone,
  PrepaymentTermsFlatPercentage,
  PrepaymentTermsYieldMaintenance,
  PrepaymentTermsAggregateInterest
} from './PrepaymentTermsVariants';
import PrepaymentSchedule from './PrepaymentSchedule/PrepaymentSchedule';
import {
  prepaymentTypes,
  NONE,
  YIELD_MAINTENANCE,  
  MAKE_WHOLE,
  FLAT_PERCENTAGE,
  DEFEASANCE,
  LOCKOUT,
  AGGREGATE_INTEREST,
  SPREAD_MAINTENANCE,
  YIELD_MAINTENANCE_AGENCY} from 'constants/prepaymentTypes';
const prepaymentTypeList = prepaymentTypes.filter(x => x.value !== LOCKOUT && x.value !== YIELD_MAINTENANCE_AGENCY );
const PrepaymentTermsGrid = styled(Grid)`
&&& {
    width:1200px;
}`

const VerticalSpacer = styled.div`
height:30px;
display:block;
`
class PrepaymentTermsChildSection extends React.Component {  
  
  renderNone = () => {
    return (
      <PrepaymentTermsNone isEditing={this.props.isEditing}/>
    )
  }
  renderYieldMaintenance = (formik) => {
    return (
      <PrepaymentTermsYieldMaintenance formik={formik} isEditing={this.props.isEditing}/>
    )
  }
  renderMakeWhole = (formik) => {
    return (
      <PrepaymentTermsMakeWhole formik={formik} isEditing={this.props.isEditing}/>
    )
  }
  renderFlatPercentage = (formik, isQuote) => {
    return (
      <PrepaymentTermsFlatPercentage formik={formik} isEditing={this.props.isEditing} isQuote={isQuote}/>
    )
  }
  renderDefeasance = (formik) => {
    return (
      <PrepaymentTermsDefeasance formik={formik} isEditing={this.props.isEditing}/>
    )
  }
  renderSpreadMaintenance = (formik) => {
    return (
      <PrepaymentTermsSpreadMaintenance formik={formik} isEditing={this.props.isEditing}/>
    )
  }

  renderAggregateInterest = (formik, isQuote) => {
    return (
      <PrepaymentTermsAggregateInterest formik={formik} isEditing={this.props.isEditing} isQuote={isQuote}/>
    )
  }

  renderBasedOnPrepaymentType = (prepaymentTypeId, formik, isQuote) => {
    switch (prepaymentTypeId) {
      case NONE:
        return this.renderNone();
      case YIELD_MAINTENANCE:
        return this.renderYieldMaintenance(formik);
      case MAKE_WHOLE:
        return this.renderMakeWhole(formik);
      case FLAT_PERCENTAGE:
        return this.renderFlatPercentage(formik, isQuote);
      case DEFEASANCE:
        return this.renderDefeasance(formik);
      case SPREAD_MAINTENANCE:
        return this.renderSpreadMaintenance(formik);        
      case AGGREGATE_INTEREST: 
        return this.renderAggregateInterest(formik, isQuote);
      default:
        break;
    }
  }



  render(){    
    const {isEditing, formik, isQuote} = this.props;
    const {values} = formik;
    const prepaymentTypeId = _.get(values, 'prepaymentTerms.prepaymentTypeId');

    return (
      <Fragment>
        <div id="loan_section_prepayment_terms">
        <ChildSectionTitle>Prepayment Terms</ChildSectionTitle>
        <PrepaymentTermsGrid container alignItems="center" direction="column">
          <SideLabelAutoCompleteWithRefInput
              label="Prepayment Type"
              id="dropdownForPrepaymentType"
              options={prepaymentTypeList}
              refFieldName="prepaymentTerms.prepaymentTypeRef"
              selectName="name"
              selectValue="value"
              fieldName="prepaymentTerms.prepaymentTypeId"
              hasBorder={prepaymentTypeId}            
              isDisabled={!isEditing}/>
              {this.renderBasedOnPrepaymentType(prepaymentTypeId,formik, isQuote)}
          </PrepaymentTermsGrid>
          <VerticalSpacer/>
          <PrepaymentSchedule 
            loanId={this.props.loanId}
            isEditing={isEditing}
            isQuote={this.props.isQuote}/>
        </div>
      </Fragment>
  )};
}
const mapStateToProps = ({ loanDetails }) => ({

});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {      
    }
  )
)(PrepaymentTermsChildSection);